import { Component, inject, input, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SortPipe } from '@core';


@Component({
  imports: [MatSelectModule, MatIconModule, SortPipe, ReactiveFormsModule, MatFormFieldModule, FormsModule],
  selector: 'avs-datapoint-picker',
  templateUrl: './datapoint-picker.component.html',
})
export class DatapointPickerComponent implements ControlValueAccessor {
  realtimeAttributes = input<{ name: string }[]>();
  ngControl = inject(NgControl, { self: true });
  readonly errorMatcher: ErrorStateMatcher = {
    isErrorState: () => {
      return !!(this.ngControl?.invalid && (this.ngControl?.touched || this.ngControl?.dirty));
    },
  };
  protected value = signal<string | null>(null);
  protected isDisabled = signal(false);

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onChange = (_: any) => {
  };
  onTouched = () => {
  };


  onValueChange(newValue: string) {
    this.value.set(newValue);
    this.onChange(newValue);
  }

  writeValue(value: string) {
    this.value.set(value);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled.set(isDisabled);
  }
}
